
  import {Component, Vue} from "vue-property-decorator";
  import AppSwitch from "@/components/AppSwitch.vue";
  import {IApp} from "@/interfaces/app.interface";
  import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
  import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";
  import {bus} from "@/plugins/bus";
  import {ICookieBanner} from "@/shared/CookieBanner/interfaces/cookie-banner.interface";

  @Component({
    components: {ThemeSwitcher, AppSwitch}
  })
  export default class ProfileTheme extends Vue {
    defaultFrontModel = {
      groupingParks: true,
      // appTableV2: false,
    };
    frontModel: any = {};
    changesVersion = 0;

    props = {
      back: ['carsXParksFlag', 'extModeFlag',],
      front: ['groupingParks',], // appTableV2
    };
    frontStorageMap = {
      groupingParks: IApp.LocalStorageKeys.SelectParksGrouping,
      // appTableV2: IApp.LocalStorageKeys.AppTableV2,
    };
    availableOptionalProps = false;

    get devMode() { return process.env.VUE_APP_MODE === 'dev'; }
    get formModel(): IProfile.DataProfile { return this.$store.state.profile.profileData; }
    get defaultForm(): IProfile.IChangeableData { return this.$store.state.profile.defaultForm; }

    get hasChanges() {
      let frontHasChanges = Object.keys(this.defaultFrontModel)
        .some(key => {
          let storageValue = localStorage.getItem(this.frontStorageMap[key]);
          let compareValue = storageValue ? JSON.parse(storageValue) : this.defaultFrontModel[key];
          return this.frontModel[key] !== compareValue;
        });
      void this.changesVersion;
      return this.$store.getters['profile/hasProfileChanges'] || frontHasChanges;
    }

    created() {
      Object.keys(this.defaultFrontModel).forEach(key => {
        Vue.set(this.frontModel, key, this.defaultFrontModel[key]);
      });
      this.setDefaultForm();

      this.availableOptionalProps = cookieBannerHelper.cookieConfig.optional;
    }

    mounted() {
      bus.$on(ICookieBanner.Event.ChangeCookieValue, () => {
        this.availableOptionalProps = cookieBannerHelper.cookieConfig.optional;
      });
    }

    setDefaultForm(revert = false) {
      this.props.back.forEach(key => {
        if (revert) this.$store.commit('profile/updateProfileProp', { name: key, value: this.defaultForm[key] });
        else this.$store.commit('profile/updateDefaultFormProp', { name: key, value: this.formModel[key] })
      });

      this.props.front.forEach(key => {
        let storageValue = localStorage.getItem(this.frontStorageMap[key]);
        Vue.set(this.frontModel, key,storageValue ? JSON.parse(storageValue) : this.defaultFrontModel[key]);
      });
    }

    async saveChanges() {
      let data = await this.$store.dispatch('profile/saveChanges');

      if (data.success) {
        this.props.front.forEach(key => {
          localStorage.setItem(this.frontStorageMap[key], JSON.stringify(this.frontModel[key]));
        });

        Object.keys(this.defaultFrontModel).forEach(key => {
          Vue.set(this.defaultFrontModel, key, this.frontModel[key]);
        });
        this.changesVersion++;
        this.setDefaultForm();
      }
    }

    setBackFormValue(value, name) {
      this.$store.commit('profile/setProfileDataProperty', { name, value });
    }

    async openCookieBanner() {
      await this.$store.dispatch('dialog/openDialog', {blockName: 'allPages', dialogName: 'cookieBannerPopup'});
    }

    async changeTabAction() {
      if (this.hasChanges) await this.saveChanges();
    }

    destroyed() {
      bus.$off(ICookieBanner.Event.ChangeCookieValue);
    }
  }
